import React from "react";
import { FaFileAlt, FaFolderOpen, FaSitemap, FaIdCard } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import logo from "../../global/img/dol/logo.svg";
import "./sidebar.scss";

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
    };
  }

  toggleClass(index, e) {
    this.setState({ activeIndex: index });
  }

  componentDidMount() {
    const { pathname } = window.location;
    let activeIndex = null;

    switch (pathname) {
      case "dashboard/application":
      case "/dashboard/":
      case "/dashboard":
      case "/":
        activeIndex = 1;
        break;
      case "/dashboard/cases":
      case "/dashboard/cases/submitted":
      case "/dashboard/cases/initiated":
      case "/dashboard/cases/historical":
        activeIndex = 2;
        break;
      default:
        activeIndex = 0;
    }

    if (pathname.indexOf("dashboard/application") > -1) activeIndex = 1;
    if (pathname.indexOf("dashboard/application/") > -1) activeIndex = 2;

    this.setState({ activeIndex: activeIndex });
  }

  render() {
    return (
      <div>
        <aside className="sidenav sticky">
          <ul className="usa-sidenav usa-sidenav-list">
            <li className="usa-sidenav-item">
              <NavLink
                onClick={this.toggleClass.bind(this, 1)}
                className="sidenav-application"
                activeClassName="usa-current sidenav-application"
                to="/dashboard/application"
              >
                <FaFileAlt />
                <span>New Application</span>
              </NavLink>
            </li>
            <li className="usa-sidenav-item">
              <NavLink
                onClick={this.toggleClass.bind(this, 2)}
                className="sidenav-application"
                activeClassName="usa-current sidenav-application"
                to="/dashboard/cases"
              >
                <FaFolderOpen />
                <span>Cases</span>
              </NavLink>
            </li>
            <li className="usa-sidenav-item">
              <NavLink
                onClick={this.toggleClass.bind(this, 0)}
                className="sidenav-application"
                activeClassName="usa-current sidenav-application"
                to="/dashboard/profiles"
              >
                <FaIdCard />
                <span>Profiles {this.state.handleItemClick}</span>
              </NavLink>
            </li>
            <li className="usa-sidenav-item">
              <NavLink
                onClick={this.toggleClass.bind(this, 3)}
                className="sidenav-application"
                activeClassName="usa-current sidenav-application"
                to="/dashboard/myenterprise"
              >
                <FaSitemap />
                <span>My Network{this.state.handleItemClick}</span>
              </NavLink>
            </li>
          </ul>
          <a
            href="/dashboard"
            title="Home"
            className="sidenav-logo"
            aria-label="Foreign Labor Application Gateway home"
          >
            <img alt="U.S. Department of Labor Official Site" src={logo} />
          </a>
        </aside>
      </div>
    );
  }
}

export default Sidebar;
